// Service Worker Registration - Optimizado para PWA + Browser
// Garantiza actualizaciones automáticas incluso en PWA instalada.

let updatePending = false;

export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = '/service-worker.js';

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log('[PWA] Service Worker registered:', registration.scope);

        // === CHEQUEO AGRESIVO DE ACTUALIZACIONES ===
        // 1. Cada 3 minutos en background
        setInterval(() => {
          registration.update().catch(() => {});
        }, 1000 * 60 * 3);

        // 2. Al volver a la app (tab focus, PWA resume)
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
          }
        });

        // 3. Al recuperar conexión
        window.addEventListener('online', () => {
          registration.update().catch(() => {});
        });

        // === MANEJAR NUEVA VERSIÓN ===
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // Nueva versión lista - activar inmediatamente
                console.log('[PWA] New version available - activating');
                updatePending = true;
                installingWorker.postMessage({ type: 'SKIP_WAITING' });
              } else {
                console.log('[PWA] Content cached for first time');
              }
            }
          };
        };

        // Si hay un SW esperando (de una sesión anterior), activarlo
        if (registration.waiting) {
          console.log('[PWA] Found waiting SW - activating immediately');
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      })
      .catch((error) => {
        console.error('[PWA] Service Worker registration failed:', error);
      });

    // Cuando el nuevo SW toma control: recargar una sola vez
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      console.log('[PWA] New SW active - reloading for fresh code');
      window.location.reload();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}

export function forceUpdate() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      // Primero intentar activar un SW en espera
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      // También forzar chequeo de actualización
      registration.update().catch(() => {});
    });
  }
}

export function clearCache() {
  return new Promise((resolve) => {
    // Limpiar via SW
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      const messageChannel = new MessageChannel();
      messageChannel.port1.onmessage = (event) => resolve(event.data?.cleared);
      navigator.serviceWorker.controller.postMessage(
        { type: 'CLEAR_ALL_CACHES' },
        [messageChannel.port2]
      );
    } else {
      // Fallback directo
      caches.keys()
        .then((names) => Promise.all(names.map((n) => caches.delete(n))))
        .then(() => resolve(true));
    }
  });
}

export function isInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
}

export function isOnline() {
  return navigator.onLine;
}
